export default "__VITE_ASSET__9bzyqA8P__"